import { useAppState } from '../../store/appstate';

/**
 * Whether the user's own organization is in the guided setup: it is the landing page and the main menu is hidden. The
 * backend decides (GET organizations/{id} answers shouldRedirectToGetStarted): the organization is in the
 * TURBO-25-guided-setup flag, has a merchant and has steps left.
 */
export const useIsGuidedSetupEnabled = () =>
    useAppState<boolean>(s => !!s.session.guidedSetup?.shouldRedirectToGetStarted);

/**
 * Whether the user's own organization has been loaded, so it is known if the setup is on. Redirects that depend on the
 * setup must wait for this. A user without an organization never loads one.
 */
export const useIsGuidedSetupLoaded = () =>
    useAppState<boolean>(
        s =>
            !!s.session.guidedSetup?.isLoaded ||
            (!s.session.isFetchingUser && !s.session.user?.organization)
    );
